import React, { useEffect, useCallback, useState} from 'react';
import {loadSampleFromProject} from 'utils/loadSampleFromProject.js';
import {getProjectsUsed} from 'utils/getProjectsUsed.js';
import {connect} from 'react-redux';

const SampleUsed = ({sample, sequencerEngine, initialShow=false}) => { 
    let [projects, setProjects] = useState([]);
    let [show, setShow] = useState(initialShow);
    let [selectedProject, setSelectedProject] = useState(undefined);
    let [numPatterns, setNumPatterns] = useState(0);
    let [selectedPattern, setSelectedPattern] = useState(0);

    useEffect(() => {
        getProjectsUsed(sample.ipfsHash).then(setProjects);
    }, [setProjects, sample]);

    const onClickProject = useCallback((e, project, patternNumber) => {
        e.stopPropagation();
        setSelectedProject(project);
        loadSampleFromProject(sequencerEngine, sample, project, patternNumber)
            .then(setNumPatterns);
        setSelectedPattern(patternNumber || 0);
    }, [setSelectedProject, sample, setNumPatterns, setSelectedPattern]);

    return (
        <div className="projects-used-in">
          {!initialShow ?
           <div className="info">
             Used in {projects.length} <span onClick={() => setShow(!show)} className={show ? "projects-btn showing" : "projects-btn"}>projects</span>
           </div> : ''}
          {show ?
           <div className="project-list">
             {projects.map(
                 project =>
                     <div
                       onClick={(e) => onClickProject(e, project)} 
                       className={project === selectedProject ? "selected project-option" : "project-option"}>
                       {project.title}
                       {selectedProject === project ?
                        <div className="patterns-chooser">
                          <div className="pattern-label">
                            Pattern: 
                          </div>
                          {Array(numPatterns).fill(0).map(
                              (x, i) =>
                                  <div
                                    onClick={(e) => onClickProject(e, project, i)}
                                    className={selectedPattern === i ? "pattern-btn selected" : "pattern-btn"}>
                                    {i+1}
                                  </div>)}
                        </div>: ''}
                     </div>)}
          </div>
         : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleUsed);
